export { default } from './TableHeadContent';
export { DEFAULT_SORT_ORDER } from './TableHeadContent.constants';
